export const spreadsheetMappingSchema = {
  $schema: 'http://json-schema.org/draft-04/schema#',
  type: 'object',
  properties: {
    accrualDate: {
      type: 'object',
      properties: {
        dateFormat: {
          type: ['string', 'null']
        },
        heading: {
          type: 'string'
        }
      },
      required: ['dateFormat', 'heading']
    },
    action: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            CLOSE: {
              type: 'string'
            },
            RESIZE: {
              type: 'string'
            },
            REPRICE: {
              type: 'string'
            },
            ROLL: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    axe: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    baseIndexValue: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    basisConvention: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            '30/360': {
              type: 'string'
            },
            'ACT/ACT': {
              type: 'string'
            },
            'ACT/ACT (Non EOM)': {
              type: 'string'
            },
            'ACT/AFB': {
              type: 'string'
            },
            'ACT/360': {
              type: 'string'
            },
            'ACT/365': {
              type: 'string'
            },
            'NL/365': {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    bic: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    bondPrice: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    book: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    bundle: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    buyOrganisation: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    buyTradingEntity: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    callablePeriodDays: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    callableType: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            NONE: {
              type: 'string'
            },
            BILATERAL: {
              type: 'string'
            },
            UNILATERAL: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    cfi: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    cleanPrice: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    clearingHouse: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            LCH: {
              type: 'string'
            },
            LCHSA: {
              type: 'string'
            },
            FICC: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    collateralType: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            STANDARD: {
              type: 'string'
            },
            INDEX_LINKED: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    collectionId: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    collectionName: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    collectionType: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            ALL_OR_NOTHING: {
              type: 'string'
            },
            ONE_CANCELS_OTHERS: {
              type: 'string'
            },
            NON_CONTINGENT: {
              type: 'string'
            },
            SEND_INDIVIDUALLY: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    counterpartyName: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    country: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    coupon: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    couponType: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            FIXED: {
              type: 'string'
            },
            FLOATING: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    csd: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            DTCC: {
              type: 'string'
            },
            EUROCLEAR: {
              type: 'string'
            },
            BONY: {
              type: 'string'
            },
            CLEARSTREAM: {
              type: 'string'
            },
            AUSTRACLEAR: {
              type: 'string'
            },
            JASDEC: {
              type: 'string'
            },
            FED: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    currency: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            AUD: {
              type: 'string'
            },
            CAD: {
              type: 'string'
            },
            DKK: {
              type: 'string'
            },
            EUR: {
              type: 'string'
            },
            GBP: {
              type: 'string'
            },
            JPY: {
              type: 'string'
            },
            SEK: {
              type: 'string'
            },
            USD: {
              type: 'string'
            },
            NZD: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    cusip: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    defaultAgreement: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            GMRA: {
              type: 'string'
            },
            GMSLA: {
              type: 'string'
            },
            MFA: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    direction: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            BUY: {
              type: 'string'
            },
            SELL: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    effectiveDate: {
      type: 'object',
      properties: {
        dateFormat: {
          type: ['string', 'null']
        },
        heading: {
          type: 'string'
        }
      },
      required: ['dateFormat', 'heading']
    },
    endDate: {
      type: 'object',
      properties: {
        dateFormat: {
          type: ['string', 'null']
        },
        heading: {
          type: 'string'
        }
      },
      required: ['dateFormat', 'heading']
    },
    externalId: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    firstCouponDate: {
      type: 'object',
      properties: {
        dateFormat: {
          type: ['string', 'null']
        },
        heading: {
          type: 'string'
        }
      },
      required: ['dateFormat', 'heading']
    },
    firstSettlementDate: {
      type: 'object',
      properties: {
        dateFormat: {
          type: ['string', 'null']
        },
        heading: {
          type: 'string'
        }
      },
      required: ['dateFormat', 'heading']
    },
    fisn: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    frequency: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            ANNUAL: {
              type: 'string'
            },
            BI_ANNUAL: {
              type: 'string'
            },
            QUARTERLY: {
              type: 'string'
            },
            MONTHLY: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    fund: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    haircut: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    haircutType: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            HAIRCUT: {
              type: 'string'
            },
            COLLATERAL: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    id: {
      type: 'string'
    },
    index: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    isin: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    issuer: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    lag: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            THREE_MONTHS: {
              type: 'string'
            },
            EIGHT_MONTHS: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    lei: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    masterLegalAgreements: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            GMRA: {
              type: 'string'
            },
            GMSLA: {
              type: 'string'
            },
            MFA: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    maturityDate: {
      type: 'object',
      properties: {
        dateFormat: {
          type: ['string', 'null']
        },
        heading: {
          type: 'string'
        }
      },
      required: ['dateFormat', 'heading']
    },
    name: {
      type: 'string'
    },
    notes: {
      type: 'object',
      properties: {
        '0': {
          type: 'object',
          properties: {
            heading: {
              type: 'string'
            }
          },
          required: ['heading']
        },
        '1': {
          type: 'object',
          properties: {
            heading: {
              type: 'string'
            }
          },
          required: ['heading']
        },
        '2': {
          type: 'object',
          properties: {
            heading: {
              type: 'string'
            }
          },
          required: ['heading']
        },
        '3': {
          type: 'object',
          properties: {
            heading: {
              type: 'string'
            }
          },
          required: ['heading']
        },
        '4': {
          type: 'object',
          properties: {
            heading: {
              type: 'string'
            }
          },
          required: ['heading']
        }
      },
      required: ['0', '1', '2', '3', '4']
    },
    notional: {
      type: 'object',
      properties: {
        decimalShift: {
          type: 'null'
        },
        heading: {
          type: 'string'
        }
      },
      required: ['decimalShift', 'heading']
    },
    organisation: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    permission: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            VIEW: {
              type: 'string'
            },
            TRADE: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    platform: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            ISIN: {
              type: 'string'
            },
            CUSIP: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    preAgreed: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    rightOfExit: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    rightOfSubstitution: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    primeBroker: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    product: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    publishedName: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    rate: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    referenceRate: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    relationshipAction: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            ADD: {
              type: 'string'
            },
            DELETE: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    repoType: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    response: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            ACCEPT: {
              type: 'string'
            },
            REJECT: {
              type: 'string'
            },
            SEND: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    rfqId: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    roll: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    sector: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    sellOrganisation: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    sellTradingEntity: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    settlementVenue: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            Bilateral: {
              type: 'string'
            },
            Direct: {
              type: 'string'
            },
            Sponsored: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    shortId: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    shortName: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    ficcShortName: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    sponsor: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            NatWest: {
              type: 'string'
            },
            SocGen: {
              type: 'string'
            },
            HSBC: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    startConsideration: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    startDate: {
      type: 'object',
      properties: {
        dateFormat: {
          type: ['string', 'null']
        },
        heading: {
          type: 'string'
        }
      },
      required: ['dateFormat', 'heading']
    },
    strategy: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    term: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    ticketSize: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    tradeId: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    tradingEntityType: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            STANDARD: {
              type: 'string'
            },
            BLOCK: {
              type: 'string'
            },
            BOTH: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    tradingStatus: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            ENABLED: {
              type: 'string'
            },
            DISABLED: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    tradingType: {
      type: 'object',
      properties: {
        defaultValue: {
          type: 'null'
        },
        heading: {
          type: 'string'
        },
        values: {
          type: 'object',
          properties: {
            CASH: {
              type: 'string'
            },
            NOTIONAL: {
              type: 'string'
            },
            EITHER: {
              type: 'string'
            }
          }
        }
      },
      required: ['defaultValue', 'heading', 'values']
    },
    type: {
      type: 'string'
    },
    unwind: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    sub: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    usSponsoredClearing: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    usSponsoredClearingDefault: {
      type: 'object',
      properties: {
        heading: {
          type: 'string'
        }
      },
      required: ['heading']
    },
    userId: {
      type: 'string'
    }
  },
  required: [
    'accrualDate',
    'action',
    'axe',
    'baseIndexValue',
    'basisConvention',
    'bic',
    'bondPrice',
    'book',
    'bundle',
    'buyOrganisation',
    'buyTradingEntity',
    'callablePeriodDays',
    'callableType',
    'cfi',
    'cleanPrice',
    'clearingHouse',
    'collateralType',
    'collectionId',
    'collectionName',
    'collectionType',
    'counterpartyName',
    'country',
    'coupon',
    'couponType',
    'currency',
    'cusip',
    'defaultAgreement',
    'direction',
    'effectiveDate',
    'endDate',
    'externalId',
    'firstCouponDate',
    'firstSettlementDate',
    'fisn',
    'frequency',
    'fund',
    'haircut',
    'haircutType',
    'id',
    'index',
    'isin',
    'issuer',
    'lag',
    'lei',
    'masterLegalAgreements',
    'maturityDate',
    'name',
    'notes',
    'notional',
    'organisation',
    'permission',
    'platform',
    'preAgreed',
    'primeBroker',
    'product',
    'publishedName',
    'rate',
    'referenceRate',
    'relationshipAction',
    'repoType',
    'response',
    'rfqId',
    'roll',
    'sector',
    'sellOrganisation',
    'sellTradingEntity',
    'settlementVenue',
    'shortId',
    'shortName',
    'sponsor',
    'startConsideration',
    'startDate',
    'strategy',
    'term',
    'ticketSize',
    'tradeId',
    'tradingEntityType',
    'tradingStatus',
    'tradingType',
    'type',
    'unwind',
    'sub',
    'usSponsoredClearing',
    'usSponsoredClearingDefault',
    'userId'
  ]
}
